import {useEffect, useRef, useState} from 'react'
import _ from 'lodash'
// Components
import StripeFormPage from '../payment/stripe-form-page'
// Types
import type {StripePayload, SubmissionObject, UploadcareFile} from '../../types/submission-wizard'
// Styles
import styles from '../submission-wizard/pay-with-stripe-step.module.scss'
import wizardStyles from '../submission-wizard/submission-wizard.module.scss'

interface PayWithStripeStepProps {
  stripePayload: StripePayload
  paymentIsProcessing: boolean
  sendPaymentIsProcessing: (isProcessing: boolean) => void
  onCastSubmission: (submission: SubmissionObject) => Promise<boolean>
  uploadcareFiles: UploadcareFile[]
  onNext: () => void
}

const PayWithStripeStep = ({
  stripePayload,
  paymentIsProcessing,
  sendPaymentIsProcessing,
  onCastSubmission,
  uploadcareFiles,
  onNext,
}: PayWithStripeStepProps) => {
  const stepRef = useRef<HTMLDivElement>(null)

  const [requiresScrolling, setRequiresScrolling] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (!stepRef.current) return
      const rect = stepRef.current.getBoundingClientRect()
      setRequiresScrolling((rect?.height + 24) > window.innerHeight)
    }
    // Run once on mount to set initial state
    handleResize()
    // Attach the current callback and clean up on unmount or when it changes
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div
      className={`
        ${wizardStyles['__step-container']}
        ${styles['__container']}
        ${requiresScrolling ? styles['--requires-scrolling'] : ''}
      `}
    >
      <div
        ref={stepRef}
        className={`
          ${styles['pay-with-stripe-step']}
          ${wizardStyles['__submission-wizard-step']}
        `}
      >
        <div className={wizardStyles['__step-header']}>
          <img
            src={_.first(uploadcareFiles)?.cdnUrl || 'https://ucarecdn.com/47a41f84-b865-4aeb-a53a-3b20cb168d46/-/preview/50x50/'}
            alt={stripePayload?.submissionName || 'Unnamed entry'}
            className={wizardStyles['__entry-thumbnail']}
          />
          <div className={wizardStyles['__entry-details']}>
            <h3 className={wizardStyles['__entry-name']}>{stripePayload?.submissionName || 'Unnamed entry'}</h3>
            <h3 className={wizardStyles['__entry-length']}>
              {`${uploadcareFiles.length || '0'} photo${uploadcareFiles.length > 1 || !uploadcareFiles.length ? 's' : ''}`}
            </h3>
          </div>
        </div>
        <StripeFormPage
          stripePayload={stripePayload}
          paymentIsProcessing={paymentIsProcessing}
          sendPaymentIsProcessing={sendPaymentIsProcessing}
          onCastSubmission={onCastSubmission}
          onNext={onNext}
        />
      </div>
    </div>
  )
}

export default PayWithStripeStep
